export class RegisterMovementRequest {
    public MovementType: string;
    public TruckingCompanyId: string;
    public TruckRegistration: string;
    public TruckTrailer: string;
    public VesselAndProcessId: string;
    public VesselDesignation: string;
    public Process: string;
    public VesselName: string;
    public PortOfLoading: string;
    public PortOfDischarge: string;
    public PortOfLoadingDescription: string;
    public PortOfDischargeDescription: string;
    public ProductCode: string;
    public EntryDate: string;
}


// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/domain/registerMovementRequest.ts